import { GestorTabFiltersBar } from '@/components/Gestores/GestorTabFiltersBar'

type Props = {
  search: string
  onSearchChange: (v: string) => void
}

export function GestorClientesFilters({ search, onSearchChange }: Props) {
  return (
    <GestorTabFiltersBar
      search={search}
      onSearchChange={onSearchChange}
      searchPlaceholder='Buscar cliente por nome ou CNPJ…'
      searchAriaLabel='Buscar clientes'
      showClear={search.trim().length > 0}
      onClearAll={() => onSearchChange('')}
    />
  )
}
